<template>
  <div v-if="list.length" :class="['aside-post__experts', className]">
    <div v-if="title.length" class="aside-post__title t1">{{ title }}</div>
    <div class="aside-post__scroll-x">
      <div class="authors-list">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="['authors-list__item', { '-w-photo': item['PHOTO'] }]"
          itemprop="author"
          itemscope
          itemtype="http://schema.org/Person"
        >
          <div class="authors-list__photo">
            <img
              v-if="getPhotoSrc(item['PHOTO'])"
              v-show="isImageLoaded(item['PHOTO'])"
              :key="getPhotoSrc(item['PHOTO'])"
              :src="getPhotoSrc(item['PHOTO'])"
              :alt="item['NAME'] || ''"
              @vue:mounted="syncImageState($event.el)"
              @load="syncImageState($event.currentTarget)"
              @error="syncImageState($event.currentTarget)"
            />
            <i
              v-if="!isImageLoaded(item['PHOTO'])"
              class="blank account"
              aria-hidden="true"
            />
          </div>
          <div class="authors-list__info">
            <div class="authors-list__name t3" itemprop="name">{{ item['NAME'] }}</div>
            <div
              v-if="
                authorProps[index]?.['PROPERTIES']?.['TEXTPOST']?.['VALUE']?.['TEXT']
                  ?.length
              "
              class="authors-list__position t3"
              itemprop="jobTitle"
              v-html="
                authorProps[index]?.['PROPERTIES']?.['TEXTPOST']?.['VALUE']?.['TEXT'] ??
                ''
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useExpertsModel } from '../model';

  // props
  const { className, list, authorProps } = defineProps({
    className: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
    authorProps: {
      type: Array,
      default: () => [],
    },
  });

  const { title, getPhotoSrc, isImageLoaded, syncImageState } = useExpertsModel();
</script>

<style scoped lang="scss">
  .blank {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 44px;
    font-family: font-icons;
    width: 100%;
    aspect-ratio: 1/1;
    border-radius: 50%;
    background-color: $black10;
    color: $black50;

    @include until($xxl) {
      font-size: 24px;
    }
  }
  .authors-list {
    display: flex;
    flex-direction: column;
    row-gap: 24px;

    @include until($lg) {
      padding-right: 64px;
      padding-left: 64px;
      flex-wrap: initial;
      flex-direction: row;
      width: min-content;
      column-gap: 24px;
    }

    @include until($md) {
      padding-right: 24px;
      padding-left: 24px;
      column-gap: 12px;
    }

    &__item {
      display: grid;
      grid-template-columns: 80px 1fr;
      column-gap: 24px;
      align-items: flex-start;

      @include until($xxl) {
        grid-template-columns: 40px 1fr;
        column-gap: 16px;
      }

      @include until($xl) {
        grid-template-columns: 1fr;
        row-gap: 12px;
      }

      @include until($lg) {
        grid-template-columns: 40px 1fr;
        width: 225px;
      }

      @include until($md) {
        width: 242px;
      }
    }

    &__photo {
      position: relative;
      aspect-ratio: 1 / 1;

      @include until($xl) {
        max-width: 40px;
      }

      img {
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
        font-size: 14px;
        line-height: 80px;
        text-align: center;

        @include until($xxl) {
          line-height: 40px;
        }
      }
    }

    &__info {
      display: flex;
      flex-direction: column;
      row-gap: 12px;
      padding-top: 15px;

      @include until($xxl) {
        padding-top: 0;
      }
    }

    &__name {
      font-weight: var(--font-weight-medium);
    }

    &__position {
      color: $black50;
    }
  }
</style>

<i18n lang="json">
{
  "ru": {
    "a_side_title_experts": "Эксперты"
  }
}
</i18n>
